// src/pages/Article.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig'; // Import Firestore

// Styled Container for the article
const ArticleContainer = styled(Container)({
  marginTop: '20px',
  marginBottom: '20px',
  padding: '20px',
  background: '#fff',
  borderRadius: '10px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center', // Center all content
});

// Styled Box for the article image
const ArticleImage = styled('img')({
  width: '100%',
  maxWidth: '800px', // Limit the maximum width for larger screens
  maxHeight: '400px',
  objectFit: 'contain', // Ensures the image is scaled smoothly
  borderRadius: '10px',
  marginBottom: '20px',
  boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
  imageRendering: 'auto', // Helps reduce pixelation
});

// Main Article component
const Article = () => {
  const { id } = useParams(); // Get article ID from URL
  const [article, setArticle] = useState(null);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const articleRef = doc(db, 'articles', id);
        const articleSnap = await getDoc(articleRef);

        if (articleSnap.exists()) {
          setArticle(articleSnap.data());
        } else {
          console.error('No such document!');
        }
      } catch (error) {
        console.error('Error fetching the article:', error);
      }
    };

    fetchArticle();
  }, [id]);

  if (!article) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <ArticleContainer>
      <Typography variant="h4" gutterBottom>
        {article.title}
      </Typography>
      <ArticleImage src={article.image} alt={article.title} />
      <Box sx={{ marginTop: '20px', lineHeight: '1.6', textAlign: 'justify', maxWidth: '800px' }}>
        <Typography variant="body1" style={{ whiteSpace: 'pre-line' }}>
          {article.fullContent}
        </Typography>
      </Box>
    </ArticleContainer>
  );
};

export default Article;
